/**
 * @generated SignedSource<<5c891ff8fe403e7042d7fae3dcf6ab66>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserStatus = "ACTIVE" | "APPEAL" | "BANNED" | "BANNED_PERMANENT" | "INACTIVE" | "PENDING" | "SCHEDULED_FOR_DELETION" | "%future added value";
export type AccountInactiveScreenQuery$variables = Record<PropertyKey, never>;
export type AccountInactiveScreenQuery$data = {
  readonly currentUser: {
    readonly scheduledDeletionAt: any | null | undefined;
    readonly status: UserStatus;
  } | null | undefined;
};
export type AccountInactiveScreenQuery = {
  response: AccountInactiveScreenQuery$data;
  variables: AccountInactiveScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduledDeletionAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountInactiveScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AccountInactiveScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3ca821c4f8529339f19df6d543a204b8",
    "id": null,
    "metadata": {},
    "name": "AccountInactiveScreenQuery",
    "operationKind": "query",
    "text": "query AccountInactiveScreenQuery {\n  currentUser {\n    status\n    scheduledDeletionAt\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "82e5a17ae0d08b64606c1aa5035c06a7";

export default node;
